import {createContext} from 'react';
import {createChartViewStore} from '../store/useChartViewStore';
import {createSecondaryChartsFiltersStore} from '../store/useSecondaryChartsFiltersStore';
import {createPrimaryChartsFiltersStore} from '../store/usePrimaryChartsFiltersStore';
import {createDashboardTypeStore} from '../store/useDashboardTypeStore';
import {createRequestsPeriodFiltersStore} from '../store/useRequestsPeriodFiltersStore';
import {createServiceRequestsStatusFiltersStore} from '../store/useServiceRequestsStatusFilterStore';
import {createDashboardServiceRequestsFiltersStore} from '../store/useDashboardServiceRequestsFiltersStore';
import {
  createDashboardArchiveFilterStore,
  createServiceRequestsArchiveFilterStore,
} from '../store/useDashboardArchiveFilterStore';

export interface ContextStores {
  chartViewStore: ReturnType<typeof createChartViewStore>;
  dashboardTypeStore: ReturnType<typeof createDashboardTypeStore>;
  primaryChartsFiltersStore: ReturnType<typeof createPrimaryChartsFiltersStore>;
  secondaryChartsFiltersStore: ReturnType<typeof createSecondaryChartsFiltersStore>;
  requestsPeriodFiltersStore: ReturnType<typeof createRequestsPeriodFiltersStore>;
  serviceRequestsStatusFilterStore: ReturnType<typeof createServiceRequestsStatusFiltersStore>;
  dashboardServiceRequestsFiltersStore: ReturnType<typeof createDashboardServiceRequestsFiltersStore>;
  dashboardArchiveFilterStore: ReturnType<typeof createDashboardArchiveFilterStore>;
  serviceRequestsArchiveFilterStore: ReturnType<typeof createServiceRequestsArchiveFilterStore>;
}

export interface StoreContextData {
  [key: string]: ContextStores | null;
}

export const StoreContext = createContext<StoreContextData>({});
